import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import en from '../translations/en';
import es from '../translations/es';
import pt from '../translations/pt';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: 'language',
    ns: ['language'],
    interpolation: { escapeValue: false },
    resources: {
      en: { language: en },
      pt: { language: pt },
      es: { language: es },
    },
    fallbackLng: {
      // Português
      pt: ['pt'],
      'pt-BR': ['pt'],
      'pt-PT': ['pt'],
      // Inglês
      en: ['en'],
      'en-US': ['en'],

      'en-GB': ['en'],
      'en-CA': ['en'],
      // Espanhol
      es: ['es'],
      'es-MX': ['es'],
      'es-ES': ['es'],
      'es-AR': ['es'],
      'es-CL': ['es'],
      // Padrão
      default: ['pt'],
    },
  });

export default i18n;
